var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSizeimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52734 5.31704C1.52734 5.26181 1.57212 5.21704 1.62734 5.21704H15.7057C15.7609 5.21704 15.8057 5.26181 15.8057 5.31704V12.2448C15.8057 12.3 15.7609 12.3448 15.7057 12.3448H1.62734C1.57212 12.3448 1.52734 12.3 1.52734 12.2448V5.31704ZM3.02734 10.8448V6.71704H4.36377V8.74878H5.86377V6.71704H7.86377V9.82129H9.36377V6.71704H11.3638V8.74878H12.8638V6.71704H14.3057V10.8448H3.02734Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeimg);
export default __webpack_public_path__ + "static/media/sizeimg.69d16e8cc26247aff66976df36d248db.svg";
export { ForwardRef as ReactComponent };